"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./FractionPagination.style"));

function FractionPagination(_ref) {
  var activeIndex = _ref.activeIndex,
      slideLength = _ref.slideLength;
  return jsx_runtime_1.jsx("div", Object.assign({
    css: styles.container
  }, {
    children: "".concat(activeIndex + 1, " / ").concat(slideLength)
  }), void 0);
}

exports.default = FractionPagination;